import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import { BrowserRouter as Router, Route, Link, Switch} from 'react-router-dom';
import { browserHistory } from 'react-router';
import Resource from "../../services/Resource";
import PrivateAPIResource from "../../services/PrivateAPIResource";
import ResourceException from '../../services/ResourceException';
import {toastr} from 'react-redux-toastr';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

class UserProfile extends React.Component{
    constructor(props) {
        super(props);

        this.id = props.userId;

        this.state = {
            dataIsFetched: false,
            directPhoneNumber: '',
            email: '',
            mobilePhone: '',
            name: '',
            phone: '',
            workingTitle: '',
            linkedIn: '',
            company: '',
            role: '',
            address: '',
            postalCode: '',
            city: '',
        };

        this.getUser();
    }

    async getUser() {
        try {
            const user = await PrivateAPIResource.get('users', this.id);

            this.setState(user);
            this.setState({dataIsFetched: true});
        } catch (err) {
            if (err instanceof ResourceException) {
                console.log(this.props.intl.formatMessage(messages.userProfileErrorGetUser) + err.message);
            }
        }
    }

    onDataExportClick() {
        Resource.get('export-data').then(() => {
            toastr.success(this.props.intl.formatMessage(messages.userProfileWeBeginToPrepareData));
            toastr.success(this.props.intl.formatMessage(messages.userProfileEmailSent));
        });
    }

    renderUserInfo() {
        if(!this.state.dataIsFetched) {
            return '';
        }

        if(!this.state.name) {
            return <div>
                {this.props.intl.formatMessage(messages.userProfileNoInformationProvided)}
            </div>
        }

        let lisContent = [
            {
                label: this.props.intl.formatMessage(messages.userProfileName),
                cont: this.state.name
            }
        ];

        if(this.state.workingTitle) {
            lisContent.push({
                label: this.props.intl.formatMessage(messages.userProfileName),
                cont: this.state.workingTitle,
            });
        }

        if(this.state.address) {
            lisContent.push({
                label: this.props.intl.formatMessage(messages.userProfileAddress),
                cont: this.state.address,
            });
        }

        if(this.state.postalCode || this.state.city) {
            lisContent.push({
                label: this.props.intl.formatMessage(messages.userProfileStreetName),
                cont: this.state.postalCode + ' ' + this.state.city,
            });
        }

        let fields = {
            directPhoneNumber: this.props.intl.formatMessage(messages.userProfileDirectPhoneNumber),
            mobilePhone: this.props.intl.formatMessage(messages.userProfileMobilePhone),
            phone: this.props.intl.formatMessage(messages.userProfilePhone),
        };

        for(let stateName in fields) {
            if(!this.state[stateName]) {
                continue;
            }

            lisContent.push({
                label: fields[stateName],
                cont: this.state[stateName],
            });
        }

        if(this.state.linkedIn) {
            let href = this.state.linkedIn;
            if(href.indexOf('http') === -1) {
                href = 'https://' + href;
            }

            lisContent.push({
                label: <span><i className="fa fa-linkedin"/> LinkedIn</span>,
                cont: <a href={href} target={'_blank'}>{this.state.linkedIn}</a>,
            });
        }

        let list = lisContent.map(function (item, key) {
            return (
                <div key={key} className="row mb-1">
                    <strong className={'col-sm-4 col-xl-2'}>{item.label}: </strong>
                    <div className={'col-sm-8 col-xl-10'}>{item.cont}</div>
                </div>
            )
        });

        return <div>
            {list}
        </div>
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-block">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <h1 className="mb-3">
                                            {this.props.intl.formatMessage(messages.userProfilePageTitle)}
                                        </h1>
                                    </div>
                                    <div className="col-sm-6 pt-2">
                                        <Link className={'btn btn-primary waves-effect pull-right list-create-button'} to={`/user/profil/${this.id}/rediger`}>Redigér</Link>
                                    </div>
                                </div>
                                <blockquote className="blockquote">
                                    <p>
                                        {this.props.intl.formatMessage(messages.userProfileDescription)}
                                    </p>
                                </blockquote>
                                <hr/>
                                <h3 className={'text-center text-uppercase'}>
                                    {this.props.intl.formatMessage(messages.userProfilePersonalInformation)}
                                </h3>
                                <br/>
                                <div className="row" style={{fontSize: '20px'}}>
                                    <div className={'col-12'}>
                                        {this.renderUserInfo()}
                                        <div className={'row'}>
                                            <strong className={'col-sm-4 col-xl-2'}>{this.props.intl.formatMessage(messages.userProfileEmail)}</strong>
                                            <div className={'col-sm-8 col-xl-10'}>
                                                <a href={'mailto:' + this.state.email}>{this.state.email}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br/>
                                <hr/>
                                <div className="row" style={{fontSize: '20px'}}>
                                    <div className={'col-12'}>
                                        <div className="button-items">
                                            <button onClick={() => this.onDataExportClick()} type="button" className="btn btn-outline-primary waves-effect waves-light">
                                                {this.props.intl.formatMessage(messages.userProfileDownloadMyDataButton)}
                                            </button>
                                            <Link to="/user/delete" className="btn btn-outline-danger waves-effect waves-light">
                                                {this.props.intl.formatMessage(messages.userProfileDeleteProfileButton)}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
};

export default injectIntl(UserProfile)




// WEBPACK FOOTER //
// ./web/src/components/users/UserProfile.jsx